import { render, staticRenderFns } from "./paytype.vue?vue&type=template&id=83956820&"
import script from "./paytype.vue?vue&type=script&lang=js&"
export * from "./paytype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports